export default __webpack_public_path__ + "static/media/bar_chart.24fe96ae.png";